import { useMatch } from 'react-router';

import { ROUTE_PATTERNS } from '@/shared/config/routes';

/**
 * True when rendering inside the chrome-less `/download/:documentType/:id` print
 * page (headless PDF export) rather than the live app.
 *
 * The URL is the source of truth for "am I exporting?", so components deep in the
 * tree with no printable equivalent of their live behavior (e.g. `AnalysisMarkdown`'s
 * interactive source citation) can derive it here — no context, no prop-drilling.
 */
export const useIsDownloadRoute = (): boolean =>
  useMatch(ROUTE_PATTERNS.DOWNLOAD_DOCUMENT) !== null;
